import axios from 'axios'
export default {
  namespaced: true,
  state: {
    notificationAdminManualGrid: [
      // {
      //     id: 123,
      //     title: 'Some title 1',
      //     body: 'Message 1',
      //     schedule: {},
      //     recipients: [1, 234, 56],
      //     created_at: '2021-11-29 14:00:00',
      //     updated_at: '2021-11-30 15:00:00',
      // },
      // {
      //     id: 456,
      //     title: 'Some title 2',
      //     body: 'Message 2',
      //     schedule: {},
      //     recipients: [3, 92],
      //     created_at: '2021-11-29 14:00:00',
      //     updated_at: '2021-11-30 15:00:00',
      // },
    ],
    notificationAdminManualTypes: [],
    notificationAdminManualShow: null,
    pageData: null,
  },
  mutations: {
    setNotificationAdminManualGrid(state, payload) {
      state.notificationAdminManualGrid = payload
    },
    setNotificationAdminManualTypes(state, payload) {
      state.notificationAdminManualTypes = payload
    },
    setNotificationAdminManualShow(state, payload) {
      state.notificationAdminManualShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    notificationAdminManualGrid: (state) => state.notificationAdminManualGrid,
    notificationAdminManualShow: (state) => state.notificationAdminManualShow,
    pageData: (state) => state.pageData,
  },
  actions: {
    onNotificationAdminManualGrid({ commit, rootState }, { limit, page, sort, search }) {
      let url =
        rootState.apiDomain +
        '/api/admin/notification/manual-notification?limit=' +
        limit +
        '&page=' +
        page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=created_at:desc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationAdminManualGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminManualTypes({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/schedule/types?notification_type=manual',
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationAdminManualTypes', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminManualShow({ commit, rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/manual-notification/' + id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationAdminManualShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminManualCreate({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        console.log(data)
        axios({
          url: rootState.apiDomain + '/api/admin/notification/manual-notification/',
          data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminManualUpdate({ rootState }, { id, data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/manual-notification/' + id,
          data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminManualDelete({ rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/manual-notification/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
